import { ReactElement, useMemo } from "react"
import classNames from "classnames"

// styles
import { iconContainer } from "./Icon.module.scss"

export const Icon = ({
  icon,
  className,
  bgColor,
  iconProps,
  borderRadius,
  id
}: {
  icon: ReactElement
  className?: string
  bgColor?: string
  iconProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  >
  borderRadius?: React.CSSProperties["borderRadius"]
  id?: string
}) => {
  const p = useMemo(() => (iconProps ? iconProps : {}), [iconProps])
  const radius = useMemo(
    () => (borderRadius ? borderRadius : 0),
    [borderRadius]
  )

  return (
    <i
      id={id}
      className={classNames(iconContainer, className)}
      style={{
        backgroundColor: bgColor ? bgColor : "transparent",
        borderRadius: radius
      }}
      {...p}
    >
      {icon}
    </i>
  )
}
